const global = window;

global.SA2 = {};
